
import styled from "styled-components";

export const Wrapper = styled.div`
.modal_custom {
  --expenses-value-color: var(--app-text);
  --expenses-placeholder-color: var(--app-text-muted);

  .ant-select-selector, .ant-input-number-outlined {
    background: var(--app-surface-alt) !important;
    border-color: var(--app-border) !important;
    min-height: 42px;
  }

  .ant-input,
  .ant-input-affix-wrapper input,
  .ant-input-number-input,
  .ant-picker-input > input,
  .ant-select-selection-item,
  .ant-select-selection-item-content,
  .form-control.form-control-solid {
    color: var(--expenses-value-color, var(--app-text)) !important;
    font-weight: 500;
  }

  .ant-input-number .ant-input-number-input {
    padding: 9px 11px;
  }

  .ant-select-selection-item {
    font-size: 13px !important;
    font-weight: 500;
  }

  .ant-select-item {
    font-size: .95rem !important;
    font-weight: 500;
  }

  .ant-select .ant-select-arrow {
    height: 22px;
    color: var(--app-text-muted) !important;
  }

  .ant-select .ant-select-selection-placeholder {
    font-size: 13px !important;
    color: var(--expenses-placeholder-color, var(--app-text-muted)) !important;
    font-weight: 400;
    opacity: 0.85;
  }

  .ant-input::placeholder,
  .ant-input-number-input::placeholder {
    color: var(--expenses-placeholder-color, var(--app-text-muted)) !important;
    font-weight: 400 !important;
    opacity: 0.85;
  }

  .ant-picker-input input {
    font-size: 13px;
  }

  .ant-form-item-label > label {
    color: var(--app-text) !important;
  }
}

[data-bs-theme="dark"] & .modal_custom {
  --expenses-value-color: #ffffff;
  --expenses-placeholder-color: #92929F;
}

.expenses-search-input {
  color: var(--app-text) !important;
  background: var(--app-surface-alt) !important;
  border-color: var(--app-border) !important;
}

.expenses-search-input::placeholder {
  color: var(--app-text-muted) !important;
  opacity: 0.85;
}

.expenses-product-name,
.expenses-product-sku {
  color: var(--app-text) !important;
}
`;
